<template>
  <div class="login-container">
    <!-- 背景图片 -->
    <div class="background-image"></div>

    <!-- 登录框 -->
    <div class="login-box">
      <!-- <el-card shadow="always" class="box-card"> -->
      <div class="card-header">
        <img class="title-logo" src="https://www.tcpcat.com/ait/axw/axwlogosmall.png" alt="艾智能 logo">
        <h1 class="title2">物联网设备管理系统</h1>
      </div>
      <!-- 表单 -->
      <el-form :model="numberValidateForm" ref="numberValidateForm" label-width="80px" class="demo-ruleForm">
        <el-form-item label="用户" prop="username" :rules="[{ required: true, message: '用户名不能为空' }]">
          <el-input @keyup.enter.native="submitForm('numberValidateForm')" placeholder="请输入用户名"
            v-model.number="numberValidateForm.username" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password" :rules="[{ required: true, message: '密码不能为空' }]">
          <el-input @keyup.enter.native="submitForm('numberValidateForm')" placeholder="请输入密码"
            v-model="numberValidateForm.password" show-password></el-input>
        </el-form-item>
        <el-form-item class="form-actions">
          <el-button type="primary" v-loading.fullscreen.lock="fullscreenLoading"
            @click="submitForm('numberValidateForm')" block>
            登 录 系 统
          </el-button>
        </el-form-item>
      </el-form>

      <!-- 注册对话框 -->
      <el-dialog title="注册账号" :visible.sync="RegisterDialog" width="600px">
        <el-form>
          <el-form-item label="用户名：" label-width="100px">
            <el-input v-model="InputUsername" autocomplete="off" maxlength="16" show-word-limit></el-input>
          </el-form-item>
          <el-form-item label="登录密码：" label-width="100px">
            <el-input v-model="InputPassword1" show-password autocomplete="off" maxlength="32"></el-input>
          </el-form-item>
          <el-form-item label="确认密码：" label-width="100px">
            <el-input v-model="InputPassword2" show-password autocomplete="off" maxlength="32"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="RegisterDialog = false">取 消</el-button>
          <!-- <el-button type="primary" @click="RegisterCommit">注 册</el-button> -->
        </div>
      </el-dialog>
      <!-- </el-card> -->
    </div>
  </div>
</template>


<script>
export default {
  data() {
    return {
      multiple: false,
      fullscreenLoading: false,
      numberValidateForm: {
        username: '',
        password: '',
      },
      //注册
      RegisterDialog: false,
      RegCid: '',
      InputUsername: '',
      InputPassword1: "",
      InputPassword2: "",
    }
  },
  created() {
    let query = this.$route.query
    console.log(query)
    if (query.u) {
      this.numberValidateForm.username = query.u
      this.numberValidateForm.password = query.p
    } else {
      this.username = ''
      this.password = ''
    }
  },
  methods: {
    async submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let res = await this.$api.login({
            username: "" + this.numberValidateForm.username,
            password: "" + this.numberValidateForm.password,
          })
          console.log(res)
          if (res.status == 1) {
            console.log("login:", res.data)
            this.$notify({
              title: '登陆成功',
              message: '欢迎使用智能设备管理系统',
              type: 'success',
            })
            this.fullscreenLoading = true

            var info = res.data
            this.$store.dispatch('Login', info)

            // 延时，加钱可以优化
            setTimeout(() => {
              this.fullscreenLoading = false
              this.$router.push({
                name: 'home',
              })
            }, 990)

          } else {
            this.$alert('用户或者密码不正确', '登陆提示', {
              confirmButtonText: '确定'
            })
          }

        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    OnRegisterClick() {
      this.$notify({
        title: '提示',
        message: '暂不支持注册',
        type: 'warning',
      })
      // RegisterDialog = true
    },

  },
}
</script>
<style scoped>
.login-container {
  position: relative;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}

.background-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url('https://www.tcpcat.com/ait/axw/axwbg.jpg');
  background-size: cover;
  background-position: center;
  z-index: -1;
}

.login-box {
  position: absolute;
  top: 50%;
  right: 50%;
  transform: translateY(-50%);
  width: 600px;
  padding: 40px;
  /* 去掉背景图片相关样式 */
  background-color: rgba(255, 255, 255, 0.77);
  /* 半透明背景 */
  border-radius: 20px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}

.box-card {
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 25px;
}

.card-header {
  text-align: center;
  margin-bottom: 30px;
}

/* .card-header {
    display: flex;
    align-items: center;
    gap: 12px;
  } */

.title-logo {
  height: 100px;
  /* 按你实际 UI 调整 */
  width: auto;
}

.title {
  /* font-family: '微软雅黑', SimLi; 使用隶书字体 */
  font-size: 45px;
  color: #333;
}



.title2 {
  /* font-family: '微软雅黑', SimLi; 使用隶书字体 */
  font-size: 40px;
  color: #333;
}

.form-actions {
  display: flex;
  justify-content: center;
}

.el-button {
  margin-left: -40px;
  width: 260px;
  height: 60px;
  font-size: 30px;
  background-color: #0011ff;
  /* 棕色 */
  color: #fff;
  /* 白色文字 */
  border: none;
  /* 去掉边框 */
  border-radius: 4px;
  /* 轻微圆角 */
  /* font-family: "微软雅黑", serif; 隶书字体 */
  text-align: center;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
  /* 添加阴影增加立体感 */
}

/* 鼠标悬停效果 */
.el-button:hover {
  background-color: #A0522D;
  /* 稍深的棕色 */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.4);
}

/* 按钮按下效果 */
.el-button:active {
  background-color: #654321;
  /* 更深的棕色 */
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2) inset;
}
</style>
